<template>
    <img
        :src="asset('assets/images/eventjet_logo_text_white.svg')"
        alt="EventJet logo"
        class="h-8 w-auto"
    />
</template>

<script>
export default {
    //
};
</script>
